<template>
  <v-card>
    <v-row>
      <v-col cols="4">
        <v-row>
          <v-col cols="6" class="mb-n4">
            <v-text-field class="input-text-size pb-0"
            label="Penalty Change Day" v-model="editItem.penaltyDate" />
          </v-col>
          <v-col cols="6" class="mb-n4 mt-3">
            <v-text-field class="input-text-size pa-0"
            label="Penalty Rate (Monthly %)" v-model="editItem.penaltyRate" />
          </v-col>
          <v-col cols="6" class="pt-0 pb-0 mb-n2">
            <!-- <v-text-field class="input-text-size pa-0"
            label="Enter Tax Year" :value="getTaxYear" disabled /> -->
            <CommonDropDowns :isItTaxYearWithoutAllYears="true"
             taxYearLabelOverride="Default Tax Year"
             @change="dataFromCommonDropDowns" :taxYearValue="editItem.taxYear" />
          </v-col>
          <v-col cols="6" class="pt-0 pb-0 mb-n2">
            <v-select
              class="input-text-size"
              label="Half Pay Amount Threshold"
              :items="halfPayAmountThresholdList"
              item-text="halfPayAmountThresholdDesc"
              item-value="halfPayAmountThreshold"
              v-model="editItem.halfPayAmountThreshold" />
          </v-col>
          <v-col cols="6" class="pt-0 pb-0 mb-n2">
            <CommonDropDowns class="mt-n3 mr-1" :isItTaxFee=true @change="dataFromCommonDropDowns"
              :taxFeeNumValue="editItem.overUnderFee"
              taxFeeLabelOverride="Over/Under Fee #" taxFeeNameOverride="overUnderFee" />
            <CommonDropDowns class="mt-n3 mr-1" :isItTaxFee=true @change="dataFromCommonDropDowns"
              :taxFeeNumValue="editItem.pennyRoundingFee"
              taxFeeLabelOverride="Penny Rounding Fee #" taxFeeNameOverride="pennyRoundingFee" />
            <label class="input-text-size">Personal Tax Warrants :</label>
            <CommonDropDowns class="mt-n3 mr-1" :isItTaxFee=true @change="dataFromCommonDropDowns"
              :taxFeeNumValue="editItem.sherifFee"
              taxFeeLabelOverride="Sheriff Fee #" taxFeeNameOverride="sherifFee" />
            <CommonDropDowns class="mt-n3 mr-1" :isItTaxFee=true @change="dataFromCommonDropDowns"
              :taxFeeNumValue="editItem.treasurerFee" taxFeeLabelOverride="Treasurer Fee #"
              taxFeeNameOverride="treasurerFee" />
            <CommonDropDowns class="mt-n3 mr-1" :isItTaxFee=true @change="dataFromCommonDropDowns"
              :taxFeeNumValue="editItem.publicationFee" taxFeeLabelOverride="Publication Fee #"
              taxFeeNameOverride="publicationFee" />
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0"
            label="Over/Under Limit" v-model="editItem.overUnderLimit" />
            <!-- This column pairs row-for-row with the fee numbers on the left, and Penny
                 Rounding has no limit to set. An empty field of the same class holds that row
                 open so Sheriff/Treasurer/Publication stay level with their fee numbers -
                 matching the height by construction rather than by a hand-tuned padding.
                 visibility:hidden also keeps it out of the tab order. -->
            <v-text-field class="input-text-size pa-0" style="visibility: hidden;"
              readonly tabindex="-1" aria-hidden="true" />
            <v-text-field class="input-text-size pa-0 pt-6" label="Sheriff Fee Amount"
              v-model="editItem.sherifFeeAmount" @blur="roundAmount('sherifFeeAmount')"
              @focus="amountToNum('sherifFeeAmount'), $event.target.select()" />
            <v-text-field class="input-text-size pa-0" label="Treasurer Fee Amount"
              v-model="editItem.treasurerFeeAmount" @blur="roundAmount('treasurerFeeAmount')"
              @focus="amountToNum('treasurerFeeAmount'), $event.target.select()" />
            <v-text-field class="input-text-size pa-0" label="Publication Fee Amount"
              v-model="editItem.publicationFeeAmount" @blur="roundAmount('publicationFeeAmount')"
              @focus="amountToNum('publicationFeeAmount'), $event.target.select()" />
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
              v-model="editItem.isAutoAddAlDelqToPTW"
              label="Auto add all delinquent taxes to PTWs" />
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
              v-model="editItem.printPaymentByLineOnDelqLetter"
              label="Print 'Payment By..' line on delinquent letter" />
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
              v-model="editItem.printSignedDateLineOnPTW"
              label="Print 'Date' line by the signatures on PTWs" />
          </v-col>
           <v-col cols="6" class="mt-n5" v-if="editItem.isAutoAddAlDelqToPTW">
            <CommonDropDowns class="input-text-size" :isItstaCode="true"
              @change="dataFromCommonDropDowns" :staCodeValue="editItem.staCode" />
          </v-col>
          <v-col cols="12" class="py-0 my-0">
            <!-- Drives the Payments on Tax Warrants report. Left unset it falls back to
                 430-439 in the backend, which is what every county but Tulsa warrants under;
                 Tulsa also needs 202/203 (warrants carried over from the old system) and 409
                 (what its new warrants stamp). -->
            <v-autocomplete
              class="input-text-size"
              label="Warrant Status Codes (Payments on Tax Warrants report)"
              hint="Leave empty to use the default 430-439 Personal Tax Warrant codes"
              persistent-hint
              multiple
              chips
              deletable-chips
              :items="selectableTaxStatusCodes"
              item-text="name"
              item-value="value"
              v-model="editItem.ptwStatusCodes" />
          </v-col>
         <v-col cols="12"
         >
         <div class="py-0 my-0">
           <v-radio-group
            v-model="editItem.taxInquiryDefaultYearScope"
            row
            mandatory
          >
            <template v-slot:label>
              <div><h5> Tax Inquiry Default Search</h5></div>
            </template>
            <v-radio
             class="input-text-size radio-and-checekbox-size"
              label="Current Year"
              value="currentYear"
            ></v-radio>
            <v-radio
             class="input-text-size radio-and-checekbox-size"
              label="All Years"
              value="allYears"
            ></v-radio>
          </v-radio-group>
          </div></v-col>
         <v-col cols="12"
         >
         <div class="py-0 my-0">
           <v-radio-group
            v-model="editItem.taxWarrantLetterFormat"
            row
            mandatory
          >
            <template v-slot:label>
              <div><h5> Tax Warrant Letter</h5></div>
            </template>
            <v-radio
             class="input-text-size radio-and-checekbox-size"
              label="Format 1"
              value="format1"
            ></v-radio>
            <v-radio
             class="input-text-size radio-and-checekbox-size"
              label="Format 2"
              value="format2"
            ></v-radio>
          </v-radio-group>
          </div></v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <v-textarea class="input-text-size" auto-grow rows="2"
              label="Payment Options Line 1:" v-model="editItem.taxWarrantPaymentOptionsLine1" />
          </v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <v-textarea class="input-text-size" auto-grow rows="3"
              label="Payment Options Line 2:" v-model="editItem.taxWarrantPaymentOptionsLine2" />
          </v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <v-textarea class="input-text-size" auto-grow rows="2"
              label="Payment Options Line 3:" v-model="editItem.taxWarrantPaymentOptionsLine3" />
          </v-col>
          <v-col cols="12">
          <div class="py-0 my-0">
            <v-radio-group
              v-model="editItem.taxWarrantLetterPrintTwoCopies"
              row
              mandatory
            >
              <template v-slot:label>
                <div><h5>Number of Copies</h5></div>
              </template>
              <v-radio
                class="input-text-size radio-and-checekbox-size"
                label="One"
                :value="false"
              ></v-radio>
              <v-radio
                class="input-text-size radio-and-checekbox-size"
                label="Two"
                :value="true"
              ></v-radio>
            </v-radio-group>
          </div>
          </v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <label class="input-text-size">Certified Mail Costs :</label>
            <v-row>
              <v-col cols="6" class="">
                <label class="input-text-size font-weight-light">Certified Fee :</label>
              </v-col>
              <v-col cols="6" class="mt-n3">
                <v-text-field class="input-text-size pa-0" @blur="roundAmount('certificateFee')"
                  @focus="amountToNum('certificateFee'), $event.target.select()"
                  v-model="editItem.certificateFee" />
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n7">
                <label class="input-text-size font-weight-light">Postage :</label>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n10">
                <v-text-field class="input-text-size pa-0" @blur="roundAmount('postage')"
                  @focus="amountToNum('postage'), $event.target.select()"
                  v-model="editItem.postage" />
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n5">
                <label class="input-text-size font-weight-light">Return Receipt Fee :</label>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n7">
                <v-text-field class="input-text-size pa-0" @blur="roundAmount('returnReceiptFee')"
                  @focus="amountToNum('returnReceiptFee'), $event.target.select()"
                  v-model="editItem.returnReceiptFee" />
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n5">
                <label class="input-text-size font-weight-light">Restricted Delivery Fee :</label>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n7">
                <v-text-field class="input-text-size pa-0"
                  @blur="roundAmount('restrictedDeliveryFee')"
                  @focus="amountToNum('restrictedDeliveryFee'), $event.target.select()"
                  v-model="editItem.restrictedDeliveryFee" />
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n5">
                <label class="input-text-size font-weight-light">Total :</label>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n7">
                <v-text-field class="input-text-size pa-0" v-model="getTotalAmount"
                  @change="getTotalAmount"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <label class="input-text-size">Current Posting Period :</label>
          </v-col>
          <v-col cols="3" class="mt-n5">
            <ClarionDateControl class="input-text-size"
              :isToggle="false" v-model="editItem.curPostPerFromDate"
              label="From Date" :isDisabled="!isSuperAdmin" />
          </v-col>
          <v-col cols="3" class="mt-n5">
            <ClarionDateControl class="input-text-size"
              :isToggle="false" v-model="editItem.curPostPerToDate"
              label="To Date" :isDisabled="!isSuperAdmin" />
          </v-col>
          <v-col cols="12" class="mt-n5">
            <v-text-field class="input-text-size pa-0 pt-0" label="Previous Uncollected Tax Amount"
              v-model="editItem.prevUncollTaxAmt" @blur="roundAmount('prevUncollTaxAmt')"
              @focus="amountToNum('prevUncollTaxAmt'), $event.target.select()"
              :disabled="!isSuperAdmin" />
          </v-col>
          <v-col cols="6" class="mt-n8">
            <ClarionDateControl class="input-text-size"
              :isToggle="false" v-model="editItem.newTaxRollDate"
              label="To Date" :isDisabled="!isSuperAdmin" />
          </v-col>
          <v-col cols="6" class="mt-n5">
            <v-text-field class="input-text-size pa-0 pt-0" label="Amount"
              v-model="editItem.newTaxRollAmt" @blur="roundAmount('newTaxRollAmt')"
              @focus="amountToNum('newTaxRollAmt'), $event.target.select()"
              :disabled="!isSuperAdmin" />
          </v-col>

        </v-row>
      </v-col>
      <v-col cols="8">
        <v-row class="d-flex align-center justify-center">
          <v-col cols="2">
            <label class="input-text-size">
              Parcel ID Format:
            </label>
          </v-col>
          <v-col cols="4">
            <v-text-field class="input-text-size pa-0" v-model="editItem.pidValue"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-checkbox class="input-text-size radio-and-checekbox-size"
              v-model="editItem.isDoPidEntry" label="PID Entry - Autofill Dashes" />
          </v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <!-- Locks the In Care Of fields for EVERYONE in this county (no admin override) and
                 stops the automatic/derived writers filling them. Existing values stay visible
                 and still print - this blocks entry, not display. -->
            <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
              v-model="editItem.disableInCareOfFields"
              label="Disable In Care Of Fields" />
          </v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
              v-model="editItem.disableAddressChangeOnPickList"
              label="Disable Address Change on Pick List" />
          </v-col>
          <v-col cols="12">
            <label class="input-text-size">Tax IDs for New Tax Records:</label>
            <v-row>
              <v-col cols="12" class="pt-0 pb-0 mt-3 mb-n2">
                <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                  v-model="editItem.allowEditsForSA"
                  label="Allow edits on tax year for special assessments" />
              </v-col>
              <v-col cols="6" class="font-weight-light"><label class="input-text-size">
                  Special Assessments start at Tax ID:</label></v-col>
              <v-col cols="5" class="pt-0 pb-0 mt-n0">
                <v-text-field class="input-text-size pa-0"
                 v-model="editItem.specialAssesment"></v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n0">
                <label class="input-text-size font-weight-light">
                  Omitted Properties start at Tax ID:</label></v-col>
              <v-col cols="5" class="pt-0 pb-0 mt-n3">
                <v-text-field class="input-text-size pa-0"
                 v-model="editItem.omittedProperties"></v-text-field>
              </v-col>
              <v-col cols="2" class="pt-0 pb-0 mt-n0">
                <label class="input-text-size font-weight-light">
                  SA Fee Number</label>
              </v-col>
              <v-col cols="2" class="pt-0 pb-0">
                <CommonDropDowns class="mt-n3 mr-1" :isItTaxFee=true
                 @change="dataFromCommonDropDowns" :taxFeeNumValue="editItem.saFee"
                 taxFeeLabelOverride="Fee Menu" taxFeeNameOverride="saFee" />
              </v-col>
              <v-col cols="2" class="pt-0 pb-0 mt-n0">
                <label class="input-text-size font-weight-light">Fee Amount:</label></v-col>
              <v-col cols="5" class="pt-0 pb-0 mt-n4">
                <v-text-field class="input-text-size pa-0" @blur="roundAmount('saFeeAmount')"
                  @focus="amountToNum('saFeeAmount'), $event.target.select()"
                  v-model="editItem.saFeeAmount" />
              </v-col>
              <v-col cols="2" class="pt-0 pb-0 mt-n0">
                <label class="input-text-size font-weight-light">
                  NSF Fee Number</label>
              </v-col>
              <v-col cols="2" class="pt-0 pb-0">
                <CommonDropDowns class="mt-n3 mr-1" :isItTaxFee=true
                 @change="dataFromCommonDropDowns" :taxFeeNumValue="editItem.nsfFee"
                 taxFeeLabelOverride="Fee Menu" taxFeeNameOverride="nsfFee" />
              </v-col>
              <v-col cols="2" class="pt-0 pb-0 mt-n0">
                <label class="input-text-size font-weight-light">Fee Amount:</label></v-col>
              <v-col cols="5" class="pt-0 pb-0 mt-n4">
                <v-text-field class="input-text-size pa-0" @blur="roundAmount('nsfFeeAmount')"
                  @focus="amountToNum('nsfFeeAmount'), $event.target.select()"
                  v-model="editItem.nsfFeeAmount" />
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n0">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                    v-model="editItem.autoAdd417OnNsfPayments" />
                  <label class="input-text-size mt-1">
                    Auto-add status code 417 on NSF payments</label>
                </div>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 mt-n0">
                <v-row>
                  <v-col cols="5">
                    <label class="input-text-size font-weight-light">
                      Wkst # for Web payments:</label>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field class="input-text-size pa-0" v-model="editItem.webPaymentNo" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <label class="input-text-size">Adjustment when updating tax record:</label>
                <v-row>
              <v-col cols="6" class="font-weight-light">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                  v-model="editItem.updateOwnerChangesAdjFlag" />
                  <label class="input-text-size mt-1">
                  Create 'Update' adjustment record for owner changes</label>
                </div>
                <div class="d-flex flex-row">
                  <label class="input-text-size mt-1">Adjustment type owner changes</label>
                  <CommonDropDowns class="input-text-size pt-0 pb-0 mt-n6 ml-1"
                  :isItTaxAdjTypes=true @change="dataFromCommonDropDowns"
                  :taxAdjTypesValue="editItem.updateOwnerChangesAdjType"
                  adjTypesNameOverride="updateOwnerChangesAdjType" />
                </div>
              </v-col>
              <v-col cols="6" class="font-weight-light">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                  v-model="editItem.updateTaxrollChangesAdjFlag" />
                  <label class="input-text-size mt-1">
                  Create 'Update' adjustment record for taxroll changes</label>
                </div>
                <div class="d-flex flex-row">
                  <label class="input-text-size mt-1">Adjustment type taxroll changes</label>
                  <CommonDropDowns class="input-text-size pt-0 pb-0 mt-n6 ml-1"
                  :isItTaxAdjTypes=true @change="dataFromCommonDropDowns"
                  :taxAdjTypesValue="editItem.updateTaxrollChangesAdjType"
                  adjTypesNameOverride="updateTaxrollChangesAdjType" />
                </div>
              </v-col>
            </v-row>
              </v-col>
              <v-col cols="6" class="font-weight-light">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                  v-model="editItem.makeReasonCodeRequired" />
                  <label class="input-text-size mt-1">Make Reason code required</label>
                </div>
              </v-col>
              <v-col cols="6" class="font-weight-light">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                  v-model="editItem.restrictAdjSavingOnTaxAmtNtMatching" />
                  <label class="input-text-size mt-1">
                    Restrict saving Create Omit when Tax Amount ≠ Calculated Amount</label>
                </div>
              </v-col>
              <v-col cols="6" class="font-weight-light">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                  v-model="editItem.additionOnInfoShet" />
                  <label class="input-text-size mt-1">Display Addition on Info Sheet</label>
                </div>
              </v-col>
              <v-col cols="6" class="font-weight-light">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                  v-model="editItem.replaceOwnerNameOnAssessorUpdates" />
                  <label class="input-text-size mt-1">
                    Replace Owner Name on Assessor Updates</label>
                </div>
              </v-col>
              <v-col cols="6" class="font-weight-light"></v-col>
              <v-col cols="6" class="font-weight-light">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                  v-model="editItem.shiftAddressLineOnAssessorUpdates" />
                  <label class="input-text-size mt-1">
                    Shift address lines for C/O name</label>
                </div>
              </v-col>
              <v-col cols="6" class="font-weight-light">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                  v-model="editItem.addPercentToCareOfNamesFromAssessor" />
                  <label class="input-text-size mt-1">
                    Add % symbol to 'In Care of' names from assessor</label>
                </div>
              </v-col>
              <v-col cols="6" class="font-weight-light">
                <div class="d-flex flex-row">
                  <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
                    color="primary"
                    v-model="editItem.addCommentOnStatementMailed" />
                  <label class="input-text-size mt-1">
                    Add Comment when Statement Mailed</label>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" @click="update">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import { taxConfigScope } from '../../util/shared/system-config-scopes';
import { amountFormat, amountToNumber, cloneItem } from '../../util/shared/vue-global';
// import { getTaxYearStatus } from '../tax/common-utils/tax-common.util';
import { PENNY_ROUNDING_DEFAULT_FEE_NUMBER } from '../tax/common-utils/tax-common.util';
import CommonDropDowns from '../tax/common-utils/CommonDropDowns.mixin.vue';
import { isAuthorised } from '../../store/auth/token';
import { authRoles } from '../../router/roleGroups';
import '../../assets/style.css';

export default {
  mixins: [CommonDropDowns],
  components: {
    CommonDropDowns,
    ClarionDateControl,
  },
  created() {
    this.handleOnCreated();
  },
  mounted() {
  },
  data() {
    return {
      originalTaxSetting: null,
      halfPayAmountThresholdList: [
        { halfPayAmountThreshold: 0.45, halfPayAmountThresholdDesc: '45%' },
        { halfPayAmountThreshold: 0.50, halfPayAmountThresholdDesc: '50%' },
      ],
    };
  },
  computed: {
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      taxStatusCodes: (state) => state.shared.taxStatusCodesShared.taxStatusCodes,
    }),
    isSuperAdmin() {
      return isAuthorised(authRoles.SuperAdmin);
    },
    editItem() {
      return this.taxSettingItem;
    },
    // mergeCodeWithName prepends a blank {name: '', value: null} option for the single-select
    // dropdowns. In a multi-select that entry is selectable, and picking it would write a null
    // into the saved list, so it is dropped here.
    selectableTaxStatusCodes() {
      return (this.taxStatusCodes || []).filter((code) => code.value !== null);
    },
    getTotalAmount() {
      const certFee = amountToNumber(this.editItem.certificateFee);
      const postage = amountToNumber(this.editItem.postage);
      const returnReceiptFee = amountToNumber(this.editItem.returnReceiptFee);
      const restrictedDeliveryFee = amountToNumber(this.editItem.restrictedDeliveryFee);
      const totalAmount = certFee + postage + returnReceiptFee + restrictedDeliveryFee;
      return amountFormat(totalAmount);
    },
    // getTaxYear() {
    //   const { currentTax } = getTaxYearStatus();
    //   return currentTax;
    // },
  },
  methods: {
    ...mapActions('SystemConfig', [
      'loadConfig', 'updateConfig',
    ]),
    ...mapActions('tax/taxInquires', [
      'callToUpdateTaxGlobalVariable',
    ]),
    ...mapActions('shared/taxStatusCodesShared', [
      'loadTaxStatusCodesSharedRecords',
    ]),
    async handleOnCreated() {
      await this.loadConfig({ requiredScope: 'taxConfig' });
      await this.loadTaxFeeMasterTypes({
        criteria: { sortBy: [{ column: 'feeNumber', direction: 'asc' }] },
        postProcessTrans: this.postProccessTaxFeeData,
        baseCrudKey: 'sharedTaxFeeMaster',
      });
      await this.loadtaxAdjTypesSharedRecords({
        criteria: {},
        postProcessTrans: this.postProccessAdjTypesData,
        baseCrudKey: 'taxAdjTypesList',
      });
      await this.loadTaxStatusCodesSharedRecords({
        criteria: {
          isTaxWarrant: false,
        },
        postProcessTrans: this.postProccessStatusCodesData,
        isItSetState: true,
      });
      this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      this.roundAmount('treasurerFeeAmount');
      this.roundAmount('sherifFeeAmount');
      // Left unformatted while unset so the personal tax warrant keeps falling back to
      // the per-record publication fees until a county actually saves an amount.
      this.roundAmountIfSet('publicationFeeAmount');
      this.roundAmount('certificateFee');
      this.roundAmount('prevUncollTaxAmt');
      this.roundAmount('newTaxRollAmt');
      this.roundAmount('postage');
      this.roundAmount('returnReceiptFee');
      this.roundAmount('restrictedDeliveryFee');
      this.roundAmount('saFeeAmount');
      this.roundAmount('nsfFeeAmount');
      this.applyDefaultPaymentOptionsLines();
      this.applyDefaultFeeNumbers();
      this.applyDefaultPtwStatusCodes();
      this.originalTaxSetting = cloneItem(this.editItem);
    },
    // Penny Rounding is statewide rather than a per-county option, so a county that has never
    // opened this screen still needs a working fee number. 555 is the number seeded into every
    // county's Tax Fee Master; a county that apportions it elsewhere just picks another.
    applyDefaultFeeNumbers() {
      if (!this.editItem.pennyRoundingFee) {
        this.$set(this.editItem, 'pennyRoundingFee', PENNY_ROUNDING_DEFAULT_FEE_NUMBER);
      }
    },
    // The warrant status multi-select needs a real array to v-model against. On a county that
    // has never saved one the key is absent, and a plain Vue 2 assignment to a key the object
    // never had is not reactive - the chips render once and then every later pick is dropped.
    // Saving the empty array is harmless: the report reads [] as "not configured" and falls
    // back to the default 430-439 codes.
    applyDefaultPtwStatusCodes() {
      if (!Array.isArray(this.editItem.ptwStatusCodes)) {
        this.$set(this.editItem, 'ptwStatusCodes', []);
      }
    },
    applyDefaultPaymentOptionsLines() {
      if (!this.editItem.taxWarrantPaymentOptionsLine1) {
        this.$set(this.editItem, 'taxWarrantPaymentOptionsLine1', 'Payment must be made payable '
          + 'to the County Treasurer by check, money order, cashier\'s check, credit card, '
          + 'debit card, or electronic check.');
      }
      if (!this.editItem.taxWarrantPaymentOptionsLine2) {
        this.$set(this.editItem, 'taxWarrantPaymentOptionsLine2', 'A fee will be charged for '
          + 'returned checks (including electronic checks). You may also pay by credit card, '
          + 'debit card, or electronic check.');
      }
      if (!this.editItem.taxWarrantPaymentOptionsLine3) {
        this.$set(this.editItem, 'taxWarrantPaymentOptionsLine3', 'A convenience fee is imposed for '
          + 'credit/debit cards and electronic payments.');
      }
      if (this.editItem.taxWarrantLetterPrintTwoCopies === undefined
        || this.editItem.taxWarrantLetterPrintTwoCopies === null) {
        this.editItem.taxWarrantLetterPrintTwoCopies = true;
      }
    },
    dataFromCommonDropDowns(val, whichField) {
      // Map statusCode to staCode for the state code dropdown
      const fieldName = whichField === 'statusCode' ? 'staCode' : whichField;
      // $set so settings the loaded config has never held yet (e.g. publicationFee on a
      // county that has not saved one) still render reactively in Vue 2.
      this.$set(this.editItem, fieldName, val);
    },
    roundAmountIfSet(val) {
      const current = this.editItem[val];
      if (current === undefined || current === null || current === '') return;
      this.roundAmount(val);
    },
    roundAmount(val) {
      const formatedAmt = amountFormat(amountToNumber(this.editItem[val]));
      this.$set(this.editItem, val, formatedAmt);
    },
    amountToNum(val) {
      const formatedAmt = amountToNumber(this.editItem[val]);
      this.editItem[val] = formatedAmt;
    },
    buildTaxConfigItem() {
      return taxConfigScope.pickFields(this.editItem);
    },
    mergeTaxConfigForSave() {
      return taxConfigScope.mergeForPersist(this.editItem);
    },
    async update() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'taxConfig',
          item: this.mergeTaxConfigForSave(),
          previousItem: this.originalTaxSetting,
          isLogAudit: true,
        };
        const ok = await this.updateConfig(payload);
        if (ok) {
          this.originalTaxSetting = cloneItem(this.editItem);
        }
        this.callToUpdateTaxGlobalVariable();
      }
    },
  },
};
</script>
